

import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

const Dasamangalalakshana = ({ data }) => {
    const horoscopeData = data || {};
    const { t } = useTranslation();
    // Prepare data as label-value pairs
    var d1 = moment.duration(horoscopeData.ayanamsa, 'minutes');
    var d2 = moment.duration(d1.asSeconds(), 'minutes');
    const ayanamsaFormated = moment({ m: d1.minutes() }).format('mm:') + moment({ m: d2.minutes(), s: d2.seconds() }).format('mm:ss');

    const items = [
        { name: t("Ganaya"), value: horoscopeData.dmL10.ganaya },
                                                    { name: t("Yoniya"), value: horoscopeData.dmL10.yoni },
                                                    { name: t("Wruksha"), value: horoscopeData.dmL10.wruksha },
                                                    { name: t("Linga"), value: horoscopeData.dmL10.linga },
                                                    { name: t("Nadi"), value: horoscopeData.dmL10.nadi },
                                                    { name: t("Pakshi"), value: horoscopeData.dmL10.pakshi },
                                                    { name: t("Gothra"), value: horoscopeData.dmL10.gothra },
                                                    { name: t("Warna"), value: horoscopeData.dmL10.warna },
                                                    { name: t("Rajju"), value: horoscopeData.dmL10.rajju },
                                                    { name: t("Bhutha"), value: horoscopeData.dmL10.bhutha },

        //new suya masa kramaya
    ];

    // Split items into rows of 3 columns each
    const rows = [];
    for (let i = 0; i < items.length; i += 3) {
        rows.push(items.slice(i, i + 3));
    }

    return (
        <div style={{ overflowX: 'auto', margin: '24px 0 0 0' }}>
            <div style={{ textAlign: 'left', marginTop: '32px', fontWeight: 'bold', fontSize: '0.8em' }}>
                දස මංගල ලක්ෂන
            </div>
          
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '14px', marginBottom: '16px' }}>
            <tbody>
                {rows.map((row, idx) => (
                    <tr key={idx}>
                        {row.map((item, colIdx) => (
                            <React.Fragment key={colIdx}>
                                <td style={{ fontWeight: 'bold', padding: '2px 4px', whiteSpace: 'nowrap' }}>{item.name}</td>
                                <td style={{ padding: '2px 4px' }}>{item.value}</td>
                            </React.Fragment>
                        ))}
                        {/* Fill empty cells if row has less than 3 items */}
                        {row.length < 3 &&
                            Array.from({ length: 3 - row.length }).map((_, i) => (
                                <React.Fragment key={`empty-${i}`}>
                                    <td></td>
                                    <td></td>
                                </React.Fragment>
                            ))
                        }
                    </tr>
                ))}
            </tbody>
        </table>
        </div>
    );
};
Dasamangalalakshana.propTypes = {
    data: PropTypes.object.isRequired,
};
export default Dasamangalalakshana;